import React from 'react'
import { Modal, Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

const BreakdownHelpModal = ({ visible, onClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL || ''
  const downloadPdfUrl = `${apiUrl}${apiUrl && !apiUrl.endsWith('/') ? '/' : ''}download_summary_pdf?module=breakdown-control`

  return (
    <Modal
      title={
        <div className='breakdown-help-header'>
          <span className='breakdown-help-header-title'>Breakdown Control Summary</span>
        </div>
      }
      open={visible}
      visible={visible}
      onCancel={onClose}
      centered
      footer={[
        <a key='download' href={downloadPdfUrl} download='Breakdown Control summary.pdf'>
          <Button type='primary' className='breakdown-help-download-btn' icon={<DownloadOutlined />}>
            Download PDF
          </Button>
        </a>
      ]}
      width={780}
      className='custom-modal breakdown-help-modal'
    >
      <div className='breakdown-help-content'>
        <div className='breakdown-help-card'>
          <div className='breakdown-help-title'>Breakdown Control</div>
          <p>
            The Breakdown Control screen displays all ULDs/AWBs which have come into the station and are currently sitting at a location mapped in the Breakdown Work area mapping page. Each work area entered into the Breakdown Work Area Mapping page will be displayed as tiles at the top of the screen. Selecting a tile displays all freight being processed at that work area. The applicable parameters for the Breakdown Control screen are :-
          </p>
          <p>
            The Breakdown Work Area Mapping page and the Handling Time page from the System Parameters Module.
          </p>
        </div>

        <div className='breakdown-help-card'>
          <div className='breakdown-help-title'>Conditions to Add</div>
          <p>
            AWBs/ULDs will be added to the Breakdown Control screen once the AWB has received an RCF message and is scanned to a location mapped in the Breakdown work area mapping page.
          </p>
        </div>

        <div className='breakdown-help-card'>
          <div className='breakdown-help-title'>Conditions to Remove</div>
          <ul className='breakdown-help-list'>
            <li>
              AWBs which are in a ULD will be marked as &apos;Broken-down&apos; once the Hub Control System receives a Breakdown FPS message. This moves the ULD to the completed list.
            </li>
            <li>
              Local shipments and BULK shipments will be marked as &apos;Broken-down&apos; once the Hub Control System receives an NFD or DLV message for the same.
            </li>
            <li>
              Other than this, AWBs are moved out of the Breakdown Control screen once the shipment is scanned to another location which is not mapped to the Breakdown work area.
            </li>
            <li>
              In cases where the Hub Control System does not receive messages for certain AWBs, users can manually mark the same as complete by ticking the checkbox on the AWB section.
            </li>
          </ul>
        </div>

        <div className='breakdown-help-card'>
          <div className='breakdown-help-title'>Order by</div>
          <p>
            By default the ULDs/AWBs are ordered by the handling time remaining, with the least handling time appearing at the top. This can be changed to sort by 1st flight out, which arranges the data in-order of the departure time of the 1st flight out of the ULDs. The data can also be sorted by type, which displays all Local shipments at the top, followed by transit and finally transit-potential.
          </p>
        </div>

        <div className='breakdown-help-card'>
          <div className='breakdown-help-title'>Filters</div>
          <p>
            The ULDs table can be filtered by using the table header filters. The filters can be applied on the ULD# - BLK, PTU, SLU or ULD ; type - Local, Transit, Transit-Potential, Mixed and N/A (ULDs/Carts which are built-up and are scanned into a location mapped to Breakdown will appear on the Breakdown Control screen with N/A as type); prod code - select from all Prod Codes available in the table; Location - select from all locations available in the table. Apart from this, AWBs can be excluded from the table all together by using the Product Exclusion filter.
          </p>
        </div>

        <div className='breakdown-help-card'>
          <div className='breakdown-help-title'>Comments</div>
          <ul className='breakdown-help-list'>
            <li>
              ULDs/AWBs will not show on the screen if they have not received a FPS message moving the AWB to a mapped Breakdown location. Other than this, if the Hub Control System does not receive an RCF message for a particular AWB, all other messages will not be processed.
            </li>
            <li>
              If the breakdown has not been completed, i.e. if all pieces of the shipment has not been taken out of the ULD, the ULD will continue to show on the Breakdown Control screen with the pending pieces count. Only once all pieces have been broken-down does the ULD move to the completed list.
            </li>
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default BreakdownHelpModal
